import styled, { css } from 'styled-components'

import breakpoints from '../../theme/breakpoints'

export const Container = styled.div<{ $withBottomBorder?: boolean }>`
  padding: 32px 12px;
  width: 100%;
  margin: 0 auto;
  height: 100%;

  ${breakpoints.up('tablet')} {
    max-width: 618px;
    border-left: 1px solid ${({ theme }) => theme.colors.pureBlack};
    border-right: 1px solid ${({ theme }) => theme.colors.pureBlack};
    padding: 32px 72px;
  }

  ${({ theme, $withBottomBorder }) =>
    $withBottomBorder &&
    css`
      border-bottom: 1px solid ${theme.colors.pureBlack};
    `};
`
